<template>
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex">


        <!-- LOGO -->


        <div class="navbar-brand-box">

          <a class="logo logo-dark">
    <span class="logo-sm">
      <img alt="" height="22" :src="'https://pona.paysol.africa/logos/pona.png'">
    </span>
            <span class="logo-lg">
    </span>
          </a>

          <a class="logo logo-light d-flex align-items-center">
    <span class="logo-sm">
      <img alt="" height="50" :src="'https://pona.paysol.africa/logos/pona.png'">
    </span>
            <span class="logo-lg me-2">
      <img alt="" height="45" :src="'https://pona.paysol.africa/logos/pona.png'">
    </span>
          </a>
        </div>

        <button onclick="toggleVerticalMenu()" id="vertical-menu-btn" class="btn btn-sm px-3 font-size-16 header-item waves-effect" type="button">
          <i class="fa fa-fw fa-bars"></i>
        </button>

      </div>

      <div class="d-flex">
        <div class="dropdown d-inline-block">
          <button id="page-header-user-dropdown" aria-expanded="false" aria-haspopup="true"
                  class="btn header-item waves-effect" data-bs-toggle="dropdown" type="button">
            <img alt="Header Avatar" class="rounded-circle header-profile-user"
                 :src="'./logos/county_logo_white.png'">
            <span class="d-none d-xl-inline-block ms-1">{{ userFullName }}</span>
            <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
          </button>
          <div class="dropdown-menu dropdown-menu-end">
            <a class="dropdown-item" href="javascript: void(0);" @click="gotTo('user-profile')">
              <i class="bx bx-user font-size-16 align-middle me-1"></i>
              <span>My Profile</span>
            </a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item text-danger" @click="logout('/')">
              <i class="bx bx-power-off font-size-16 align-middle me-1 text-danger"></i>
              <span>Logout</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </header>



  <div id="vertical-menu" class="vertical-menu">
    <div class="h-100" data-simplebar>
      <div id="sidebar-menu">
        <ul id="side-menu" class="metismenu list-unstyled text-capitalize">

          <!-- Dashboard -->
          <li v-if="getRight('DASHBOARD')" :class="{ 'mm-active': selected === 'dashboard' }">
            <a @click.prevent="gotToSelected('dashboard', $event)" class="waves-effect" href="javascript:void(0);">
              <i class="bx bx-home-circle"></i><span>Dashboard</span>
            </a>
          </li>

          <li v-if="getRight('ADD HOSPITAL')" :class="{ 'mm-active': selected === 'hospitals-add' }">
            <a @click.prevent="gotToSelected('hospitals-add', $event)" class="waves-effect" href="javascript:void(0);">
              <i class="mdi mdi-medical-bag"></i><span>Add Hospital</span>
            </a>
          </li>

          <li v-if="getRight('HOSPITALS')" :class="{ 'mm-active': selected === 'hospitals' }">
            <a @click.prevent="gotToSelected('hospitals', $event)" class="waves-effect" href="javascript:void(0);">
              <i class="mdi mdi-hospital-building"></i><span>Hospitals</span>
            </a>
          </li>


          <hr v-if="getRight('MEMBER MANAGEMENT')">

          <li v-if="getRight('MEMBER MANAGEMENT')" class="menu-title" key="t-pages">Member Management</li>

          <li v-if="getRight('ADD MEMBER')" :class="{ 'mm-active': selected === 'members-add' }">
            <a @click.prevent="gotToSelected('members-add', $event)" class="waves-effect" href="javascript:void(0);">
              <i class="bx bx-user-plus"></i><span>Add Member</span>
            </a>
          </li>

          <li v-if="getRight('ALL MEMBERS')" :class="{ 'mm-active': selected === 'members-all' }">
            <a @click.prevent="gotToSelected('members-all', $event)" class="waves-effect" href="javascript:void(0);">
              <i class="bx bx-group"></i><span>All Members</span>
            </a>
          </li>

          <li v-if="getRight('BULK UPLOAD MEMBERS')" :class="{ 'mm-active': selected === 'bulk-upload-members' }">
            <a @click.prevent="gotToSelected('bulk-upload-members', $event)" class="waves-effect" href="javascript:void(0);">
              <i class="bx bx-upload me-2"></i><span>Bulk Upload Members</span>
            </a>
          </li>

          <li v-if="getRight('PLANS MANAGEMENT')" :class="{ 'mm-active': selected === 'plans-management' }">
            <a @click.prevent="gotToSelected('plans-management', $event)" class="waves-effect" href="javascript:void(0);">
              <i class="bx bx-shield"></i><span>Plans Management</span>
            </a>
          </li>

          <!-- Premiums Management -->
          <li v-if="getRight('PREMIUMS MANAGEMENT')" :class="{ 'mm-active': selected === 'premiums' }">
            <a @click.prevent="selectedMenu('premiums', $event)" class="waves-effect has-arrow" href="javascript:void(0);">
              <i class="mdi mdi-cash-multiple"></i>
              <span>Premiums Management</span>
            </a>
            <ul :class="{ 'mm-show': selected === 'premiums' }" class="sub-menu" aria-expanded="false">
              <li v-if="getRight('RECEIVE PREMIUM')" :class="{ 'mm-active': selectedSub === 'premium-receive' }">
                <a href="javascript: void(0);" @click.prevent.stop="gotTo('premium-receive', $event)">Receive Premium</a>
              </li>
              <li v-if="getRight('PREMIUM RECORDS')" :class="{ 'mm-active': selectedSub === 'premium-records' }">
                <a href="javascript: void(0);" @click.prevent.stop="gotTo('premium-records', $event)">Premium Records</a>
              </li>
              <li v-if="getRight('PREMIUM RECONCILIATION')" :class="{ 'mm-active': selectedSub === 'premium-reconciliation' }">
                <a href="javascript: void(0);" @click.prevent.stop="gotTo('premium-reconciliation', $event)">Premium Reconciliation</a>
              </li>

              <li v-if="getRight('PREMIUM COLLECTIONS REPORT')" :class="{ 'mm-active': selectedSub === 'premium-collections-report'}">
                <a href="javascript: void(0);" @click.prevent.stop="gotTo('premium-collections-report', $event)">Premium Collections Reports</a>
              </li>

              <!--              <li v-if="getRight('CASH COLLECTION')" :class="{ 'mm-active': selectedSub === 'cash-collection'}">
                              <a href="javascript: void(0);" @click.prevent.stop="gotTo('cash-collection', $event)">Cash Collection</a>
                            </li>-->

            </ul>
          </li>


          <hr v-if="getRight('CLAIMS SETTLEMENT')">
          <li v-if="getRight('CLAIMS SETTLEMENT')" class="menu-title" key="t-pages">Claims Settlement</li>

          <li v-if="getRight('CLAIMS MANAGEMENT')" :class="{ 'mm-active': selected === 'claims-management' }">
            <a @click.prevent="gotToSelected('claims-management', $event)" class="waves-effect" href="javascript:void(0);">
              <i class="mdi mdi-file-document-multiple"></i><span>Claims Management</span>
            </a>
          </li>

          <li v-if="getRight('SETTLEMENT MANAGEMENT')" :class="{ 'mm-active': selected === 'settlement-management' }">
            <a @click.prevent="gotToSelected('settlement-management', $event)" class="waves-effect" href="javascript:void(0);">
              <i class="mdi mdi-bank-transfer"></i><span>Settlement Management</span>
            </a>
          </li>


          <li v-if="getRight('COLLECTOR HANDOVER MANAGEMENT')" class="menu-title" key="t-pages">Cash Control</li>

          <li v-if="getRight('COLLECTOR HANDOVER MANAGEMENT')" :class="{ 'mm-active': selected === 'collector-handover-management' }">
            <a @click.prevent="gotToSelected('collector-handover-management', $event)" class="waves-effect" href="javascript:void(0);">
              <i class="bx bx-transfer"></i><span>Collector Handover Management</span>
            </a>
          </li>



          <!-- Add this section to Navigation.vue after the Settlement Management section -->

          <hr v-if="getRight('HEALTH EXTENSION WORKER')">
          <li v-if="getRight('HEALTH EXTENSION WORKER')" class="menu-title" key="t-pages">Health Extension Worker</li>

          <!-- HEW Dashboard -->
          <li v-if="getRight('HEW DASHBOARD')" :class="{ 'mm-active': selected === 'hew-dashboard' }">
            <a @click.prevent="gotToSelected('hew-dashboard', $event)" class="waves-effect" href="javascript:void(0);">
              <i class="bx bx-home-heart"></i><span>HEW Dashboard</span>
            </a>
          </li>

          <!-- Household Management -->
          <li v-if="getRight('HEW HOUSEHOLDS')" :class="{ 'mm-active': selected === 'hew-households' }">
            <a @click.prevent="selectedMenu('hew-households', $event)" class="waves-effect has-arrow" href="javascript:void(0);">
              <i class="bx bx-home-circle"></i>
              <span>Household Management</span>
            </a>
            <ul :class="{ 'mm-show': selected === 'hew-households' }" class="sub-menu" aria-expanded="false">
              <li v-if="getRight('HOUSEHOLD MANAGEMENT')" :class="{ 'mm-active': selectedSub === 'household-management' }">
                <a href="javascript: void(0);" @click.prevent.stop="gotTo('household-management', $event)">All Households</a>
              </li>


            </ul>
          </li>

          <!-- Health Services -->
          <li v-if="getRight('HEW SERVICES')" :class="{ 'mm-active': selected === 'hew-services' }">
            <a @click.prevent="selectedMenu('hew-services', $event)" class="waves-effect has-arrow" href="javascript:void(0);">
              <i class="bx bx-plus-medical"></i>
              <span>Health Services</span>
            </a>
            <ul :class="{ 'mm-show': selected === 'hew-services' }" class="sub-menu" aria-expanded="false">


              <li v-if="getRight('HEALTH EDUCATION')" :class="{ 'mm-active': selectedSub === 'health-education' }">
                <a class="mdi mdi-school" href="javascript: void(0);" @click.prevent.stop="gotTo('health-education', $event)">Health Education</a>
              </li>
            </ul>
          </li>

          <!-- Disease Surveillance -->
          <li v-if="getRight('DISEASE SURVEILLANCE')" :class="{ 'mm-active': selected === 'disease-surveillance' }">
            <a @click.prevent="gotToSelected('disease-surveillance', $event)" class="waves-effect" href="javascript:void(0);">
              <i class="bx bx-shield-quarter"></i><span>Disease Surveillance</span>
            </a>
          </li>

          <!-- HEW Reports -->
          <li v-if="getRight('HEW REPORTS')" :class="{ 'mm-active': selected === 'hew-reports' }">
            <a @click.prevent="gotToSelected('hew-reports', $event)" class="waves-effect" href="javascript:void(0);">
              <i class="bx bx-bar-chart-alt-2"></i><span>HEW Reports</span>
            </a>
          </li>


          <hr v-if="getRight('SYSTEM ADMINISTRATION')">
          <li v-if="getRight('SYSTEM ADMINISTRATION')" class="menu-title" key="t-pages">System Administration</li>


          <!-- Org Structure -->
          <li v-if="getRight('ORG STRUCTURE')" :class="{ 'mm-active': selected === 'org-structure' }">
            <a @click.prevent="selectedMenu('org-structure', $event)" class="waves-effect has-arrow" href="javascript:void(0);">
              <i class="mdi mdi-sitemap"></i>
              <span>Org Structure</span>
            </a>
            <ul :class="{ 'mm-show': selected === 'org-structure' }" class="sub-menu" aria-expanded="false">
              <li v-if="getRight('ORG DESIGNATIONS')" :class="{ 'mm-active': selectedSub === 'org-designations' }">
                <a  href="javascript: void(0);" @click.prevent.stop="gotTo('org-designations', $event)">Designations</a>
              </li>
              <li v-if="getRight('ORG DEPARTMENTS')" :class="{ 'mm-active': selectedSub === 'org-departments' }">
                <a href="javascript: void(0);" @click.prevent.stop="gotTo('org-departments', $event)">Departments</a>
              </li>
              <li v-if="getRight('EMPLOYMENT TYPES')" :class="{ 'mm-active': selectedSub === 'employment-types' }">
                <a href="javascript: void(0);" @click.prevent.stop="gotTo('employment-types', $event)">Employment Types</a>
              </li>
              <li v-if="getRight('AFFILIATED INSTITUTIONS')" :class="{ 'mm-active': selectedSub === 'affiliated-institutions' }">
                <a href="javascript: void(0);" @click.prevent.stop="gotTo('affiliated-institutions', $event)">Affiliated Institutions</a>
              </li>

              <li v-if="getRight('SYSTEM MANAGEMENT')" :class="{ 'mm-active': selectedSub === 'system-management' }">
                <a href="javascript: void(0);" @click.prevent.stop="gotTo('system-management', $event)">System Management</a>
              </li>


            </ul>
          </li>

          <!-- Users -->
          <li v-if="getRight('USERS')" :class="{ 'mm-active': selected === 'users' }">
            <a @click.prevent="selectedMenu('users', $event)" class="waves-effect has-arrow" href="javascript:void(0);">
              <i class="mdi mdi-account-multiple-outline"></i>
              <span>Users</span>
            </a>
            <ul :class="{ 'mm-show': selected === 'users' }" class="sub-menu" aria-expanded="false">
              <li v-if="getRight('USER REGISTRATION')" :class="{ 'mm-active': selectedSub === 'user-registration' }">
                <a href="javascript: void(0);" @click.prevent.stop="gotTo('user-registration', $event)">Add Users</a>
              </li>
              <li v-if="getRight('USER USERLIST')" :class="{ 'mm-active': selectedSub === 'user-userlist' }">
                <a href="javascript: void(0);" @click.prevent.stop="gotTo('user-userlist', $event)">Manage Users</a>
              </li>
              <li v-if="getRight('USERS DEACTIVATED')" :class="{ 'mm-active': selectedSub === 'users-deactivated' }">
                <a href="javascript: void(0);" @click.prevent.stop="gotTo('users-deactivated', $event)">Deactivated Users</a>
              </li>
              <li v-if="getRight('USE LOGS')" :class="{ 'mm-active': selectedSub === 'use-logs' }">
                <a href="javascript: void(0);" @click.prevent.stop="gotTo('use-logs', $event)">System Logs</a>
              </li>

            </ul>
          </li>


          <li v-if="getRight('ROLE MANAGEMENT')" :class="{ 'mm-active': selected === 'role-management' }">
            <a @click.prevent="gotToSelected('role-management', $event)" class="waves-effect" href="javascript:void(0);">
              <i class="bx bx-crown"></i><span>Role Management</span>
            </a>
          </li>


        </ul>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import {authUrl, biller, execute, getRight} from "@/api";

export default {
  name: 'NavigationBar',
  data() {
    return {
      selectedSub: null,
      selected: null,
      userFullName: '',
      metisMenu: null,
    };
  },
  methods:{
    getRight(type){
      return getRight(type)
    },
    selectedMenu(selected, event){
      // Check if clicking the same menu item
      if (this.selected === selected) {
        // Toggle: if it's already selected, deselect it to close
        this.selected = null;
        sessionStorage.removeItem("selected");
      } else {
        // If another menu is open, close it first with a small delay for smooth transition
        if (this.selected && this.selected !== selected) {
          const previousSelected = this.selected;
          this.selected = null;

          // Small delay to allow close animation before opening new menu
          setTimeout(() => {
            this.selected = selected;
            sessionStorage.setItem("selected", selected);
          }, 300);
        } else {
          // No menu was open, just open the selected one
          this.selected = selected;
          sessionStorage.setItem("selected", selected);
        }
      }
    },

    gotToSelected(selected, event){
      sessionStorage.setItem("selected", selected);
      sessionStorage.setItem("selectedSub", selected);
      this.selected = selected;
      this.selectedSub = selected;
      this.$router.push(selected);
    },

    gotTo(route, event){
      sessionStorage.setItem("selectedSub", route);
      sessionStorage.setItem("currentPage", route);
      this.selectedSub = route;
      this.$router.push(route);
      // Close mobile menu after navigation
      this.closeMobileMenu();
    },

    logout(route){
      const data = new FormData();
      data.append("function", "logout");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));

      execute(data, authUrl)
          .then((res) => {
            sessionStorage.clear();
            this.$router.push(route);
          })
          .catch((e) => {
            sessionStorage.clear();
            this.$router.push(route);
          });
    },

    toggleVerticalMenu() {
      // Get the vertical menu element
      const verticalMenu = document.getElementById('vertical-menu');
      const body = document.body;

      if (verticalMenu) {
        // Toggle mobile menu visibility
        if (window.innerWidth <= 768) {
          // For mobile devices
          verticalMenu.classList.toggle('show-mobile-vertical');
          body.classList.toggle('sidebar-enable');
        } else {
          // For desktop - toggle collapsed state
          body.classList.toggle('vertical-collpsed');

          // Store the state in sessionStorage
          const isCollapsed = body.classList.contains('vertical-collpsed');
          sessionStorage.setItem('menuCollapsed', isCollapsed);
        }
      }
    },

    closeMobileMenu() {
      if (window.innerWidth <= 768) {
        const verticalMenu = document.getElementById('vertical-menu');
        const body = document.body;

        if (verticalMenu) {
          verticalMenu.classList.remove('show-mobile-vertical');
          body.classList.remove('sidebar-enable');
        }
      }
    },

    restoreMenuState() {
      const isCollapsed = sessionStorage.getItem('menuCollapsed') === 'true';
      if (isCollapsed && window.innerWidth > 768) {
        document.body.classList.add('vertical-collpsed');
      }
    },

    handleResize() {
      const verticalMenu = document.getElementById('vertical-menu');
      const body = document.body;

      if (window.innerWidth > 768) {
        // Remove mobile-specific classes when switching to desktop
        if (verticalMenu) {
          verticalMenu.classList.remove('show-mobile-vertical');
        }
        body.classList.remove('sidebar-enable');
      } else {
        // Remove desktop collapse class when switching to mobile
        body.classList.remove('vertical-collpsed');
      }
    },

    handleOutsideClick(event) {
      const menu = document.getElementById('vertical-menu');
      const menuBtn = document.getElementById('vertical-menu-btn');

      if (window.innerWidth <= 768 &&
          menu &&
          !menu.contains(event.target) &&
          !menuBtn.contains(event.target) &&
          document.body.classList.contains('sidebar-enable')) {
        this.closeMobileMenu();
      }
    },

    destroyMetisMenu() {
      if (this.metisMenu) {
        // Remove all event listeners
        const menuElement = document.querySelector('#side-menu');
        if (menuElement) {
          const newMenuElement = menuElement.cloneNode(true);
          menuElement.parentNode.replaceChild(newMenuElement, menuElement);
        }
        this.metisMenu = null;
      }
    }
  },

  mounted() {
    // Get fullName from sessionStorage (this is what's saved from the login API response)
    this.userFullName = sessionStorage.getItem("fullName") || 'User';

    // Restore selected states from session storage
    this.selected = sessionStorage.getItem("selected");
    this.selectedSub = sessionStorage.getItem("selectedSub");

    // Restore menu collapsed state
    this.restoreMenuState();

    // Handle window resize to adjust menu behavior
    window.addEventListener('resize', this.handleResize);

    // Close mobile menu when clicking outside
    document.addEventListener('click', this.handleOutsideClick);

    // Make toggleVerticalMenu available globally for onclick attribute
    window.toggleVerticalMenu = () => this.toggleVerticalMenu();

    // Important: Do not initialize MetisMenu if you want full control
    // Option 1: Don't use MetisMenu at all (recommended)
    // The mm-show and mm-active classes will work with your Vue logic

    // Option 2: If you must use MetisMenu for styling, delay its initialization
    // and use a more compatible configuration
    this.$nextTick(() => {
      // Only initialize if you need MetisMenu features
      // Consider removing this entirely if not needed
      /*
      const MetisMenu = require('metismenujs').MetisMenu;
      this.metisMenu = new MetisMenu('#side-menu', {
        toggle: false,
        preventDefault: true,
        triggerElement: '.has-arrow',
        parentTrigger: 'li',
        subMenu: 'ul'
      });
      */
    });
  },

  beforeDestroy() {
    this.destroyMetisMenu();
    window.removeEventListener('resize', this.handleResize);
    document.removeEventListener('click', this.handleOutsideClick);
    delete window.toggleVerticalMenu;
  }
};
</script>

<style>
/* Smooth animation for submenus */
.sub-menu {
  max-height: 0;
  overflow: hidden;
  opacity: 0;
  transform: translateY(-10px);
  transition: max-height 0.6s ease-out,
  opacity 0.5s ease-out,
  transform 0.5s ease-out;
}

.sub-menu.mm-show {
  max-height: 1000px; /* Large enough to accommodate content */
  opacity: 1;
  transform: translateY(0);
}

/* Animate the arrow rotation */
.has-arrow {
  position: relative;
}

.has-arrow:after {
  content: "\f0140";
  font-family: "Material Design Icons";
  display: inline-block;
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%) rotate(0deg);
  transition: transform 0.5s ease;
}

.mm-active > a.has-arrow:after {
  transform: translateY(-50%) rotate(-90deg);
}

/* Add hover effects */
.metismenu li a {
  cursor: pointer;
  position: relative;
  transition: background-color 0.4s ease, padding-left 0.4s ease;
}

.metismenu li a:hover {
  background-color: rgba(255, 255, 255, 0.05);
  padding-left: 25px;
}

/* Submenu items hover effect */
.sub-menu li a {
  padding-left: 45px !important;
  transition: all 0.4s ease;
}

.sub-menu li a:hover {
  padding-left: 50px !important;
  background-color: rgba(255, 255, 255, 0.08);
}

/* Active menu item styling */
.mm-active > a {
  background-color: rgba(255, 255, 255, 0.1);
  position: relative;
  transition: background-color 0.5s ease;
}

.mm-active > a:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  background-color: #5664d2;
  animation: slideIn 0.5s ease;
}

@keyframes slideIn {
  from {
    transform: translateX(-3px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

/* Smooth transition for menu items */
.metismenu li {
  transition: all 0.3s ease;
}

/* Add subtle shadow to opened menus */
.mm-active > .sub-menu {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.05),
  inset 0 -1px 0 rgba(0, 0, 0, 0.1);
}

.page-topbar {
  transition: margin-left 0.3s ease;
}

.page-topbar-minimize {
  margin-left: 80px;
}

.hide-vertical-menu {
  display: none;
}

.content-minimize {
  transition: margin-left 0.3s ease;
  margin-left: 250px;
  overflow: hidden;
}

/* Fixed mobile menu styles */
@media (max-width: 768px) {
  #vertical-menu {
    display: none;
    position: fixed;
    left: 0;
    top: 70px; /* Adjust based on your header height */
    height: calc(100vh - 70px);
    z-index: 1001;
    background-color: #2a3042; /* Adjust to match your theme */
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);
    transition: transform 0.3s ease;
    transform: translateX(-100%);
  }

  #vertical-menu.show-mobile-vertical {
    display: block !important;
    transform: translateX(0);
  }

  body.sidebar-enable #vertical-menu {
    display: block;
    transform: translateX(0);
  }

  /* Add overlay for mobile menu */
  body.sidebar-enable::before {
    content: "";
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000;
  }

  .content-minimize {
    margin-left: 0 !important;
  }
}

/* Desktop collapsed state */
.vertical-collpsed #vertical-menu {
  width: 70px;
  transition: width 0.3s ease;
}

.vertical-collpsed #vertical-menu .logo-lg,
.vertical-collpsed #vertical-menu .portal-title,
.vertical-collpsed #vertical-menu span:not(.logo-sm):not(i) {
  display: none;
}

.vertical-collpsed #vertical-menu .has-arrow:after {
  display: none;
}

.vertical-collpsed .content-minimize {
  margin-left: 70px;
  transition: margin-left 0.3s ease;
}

/* Ensure smooth transitions */
#vertical-menu,
.content-minimize {
  transition: all 0.3s ease;
}

@media print {
  .footer,
  .navbar-header,
  .page-title-box,
  .right-bar,
  .vertical-menu {
    display: none!important
  }
  .card-body,
  .content-minimize,
  .page-content,
  .right-bar,
  body {
    padding: 0;
    margin: 0
  }
  .card {
    border: 0
  }
}

.content-minimize {
  margin-left: 250px;
  overflow: hidden
}

.content-minimize .content {
  padding: 0 15px 10px 15px;
  margin-top: 70px
}

@media (max-width:992px) {
  .vertical-menu {
    display: none
  }
  .content-minimize {
    margin-left: 0!important
  }
  body.sidebar-enable .vertical-menu {
    display: block
  }

  #vertical-menu.show-mobile-vertical{
    display: block !important;
  }
}

.vertical-collpsed .content-minimize {
  margin-left: 70px
}

body[data-layout=horizontal] .content-minimize {
  margin-left: 0!important
}

body[data-sidebar-size=small] .content-minimize {
  margin-left: 160px
}

body[data-sidebar-size=small].vertical-collpsed .content-minimize {
  margin-left: 70px
}
</style>